import React, { useEffect } from "react";
import styled from "styled-components";
import colors from "../../../../../theme/colors";
import {
  ProductDetailPanelHeaderInline,
  ProductDetailPanelHeaderRow,
} from "../ProductDetailPanelHeader";
import { useDispatch } from "react-redux";
import { getPropertyPrioritiesList } from "../../../../../store/reducers/products/propertyPriorities/pl-propertyPriorities.action";
import { useTypedSelector } from "../../../../../store";
import { selectProductLineId } from "../../../../../store/reducers/products/products.selectors";
import PropertyPriority from "./PropertyPriority.component";
import AddPriorityListButton from "./AddPriorityListButton.component";

export function PropertyPrioritiesList() {
  const dispatch = useDispatch();
  const selectedProductLineId = useTypedSelector(selectProductLineId);
  const propertyPriorityList = useTypedSelector(
    (state) => state.products.propertyPriorities.byId
  );
  const getting = useTypedSelector(
    (state) => state.products.propertyPriorities.getting
  );

  useEffect(() => {
    if (!selectedProductLineId) return;
    dispatch(getPropertyPrioritiesList());
  }, [selectedProductLineId]);

  if (getting) return null;

  return (
    <Wrapper>
      <PrioritiesHeaderRow>
        <ProductDetailPanelHeaderInline bold color={colors.muttedHeadlines}>
          Property Priority Lists by Ruleset
        </ProductDetailPanelHeaderInline>
        <AddPriorityListButton />
      </PrioritiesHeaderRow>
      <PropertyPrioritiesListWrapper>
        {Object.keys(propertyPriorityList).map((el) => (
          <PropertyPriority key={el} data={propertyPriorityList[el]} />
        ))}
      </PropertyPrioritiesListWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const PrioritiesHeaderRow = styled(ProductDetailPanelHeaderRow)`
  justify-content: space-between;
`;

const PropertyPrioritiesListWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-content: flex-start;
  gap: 32px;
  padding: 0 32px 32px;
`;
